<template>
  <standard-layout :only-main="true">
    <template v-slot:heading>
      <router-link tag="div"
                   :to="{name: 'administration'}"
                   :style="{cursor: $route.name === 'administration' ? 'default' : 'pointer'}">
        <sakali-header
            v-if="$route.name === 'administration'"
            title="Administration"/>
        <sakali-header
            v-else
            :title="$route.meta.displayName"
            super-title="Administration"/>
      </router-link>
    </template>
    <template v-slot:main>
      <div v-if="$route.name === 'administration'"
           class="mt-3 container">
        <p>
          <router-link tag="a"
                       :to="{name: 'administrationSpecialBets'}">
            Sondertipps bearbeiten
          </router-link>
        </p>
        <p>
          <router-link tag="a"
                       :to="{name: 'administrationTeams'}">
            Teams bearbeiten
          </router-link>
        </p>
        <p>
          <time-editor/>
        </p>
        <div>
          <div class="h5">Jobs</div>
          <div class="d-flex">
            <button class="btn btn-sakali btn-sm" @click="triggerJob('updateMatches')">
              Spielberechnung anstoßen
            </button>
          </div>
        </div>
      </div>
      <router-view class="mt-3 pe-3"/>
    </template>
  </standard-layout>
</template>
<script>
import StandardLayout from "@/layouts/StandardLayout";
import TimeEditor from "@/admin/TimeEditor";

export default {
  methods: {
    triggerJob(jobName) {
      this.$api.post('/admin/job/' + jobName).then(response => {
        this.showMessage({
          message: 'Job ausgeführt mit Ergebnis: ' + response.data
        })
      }).catch(error => this.handleError(error))
    }
  },
  components: {TimeEditor, StandardLayout}
}
</script>